module.exports = {
  //ArrayScalar: require('./ArrayeNode').ArrayScalar,
  //BoolScalar: require('./BoolNode').BoolScalar,
  //CharScalar: require('./CharNode').CharScalar,
  DateScalar: require('./DateScalar'),
  //EmailScalar: require('./EmailNode').EmailScalar,
  //PriceScalar: require('./PriceNode').PriceScalar,
  TextScalar: require('./TextScalar')
};


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/scalars/index.js
 **/